import { PRE_CREATE_TOKEN_STRIPE } from "../types/restaurant.types";

export const createTokenRestaurant = (authCode, idRestaurant) => {
  return { type: PRE_CREATE_TOKEN_STRIPE, authCode, idRestaurant };
};
